import React,{useEffect,useState} from 'react'
import { Form,Row,Col,message} from 'antd'
import {useLocation} from 'react-router-dom'
import './index.scss'
import Request from "../../networkReq/request";
import Http from "../../networkReq/http";
import Default from "../../img/Default.png"
const FormItem = Form.Item
export default function JobFairDetail(props) {
    const Location = useLocation()
    const [detailInfo,setDetailInfo] = useState({})

    useEffect(()=>{
        console.log('Location',Location);
        let detailId =Location.pathname.split('/').slice(-1)[0]
        console.log(detailId);
        Http.get(Request.getJobFairDetail(), { id:detailId}, (obj) => {
            if (obj.code == 200) {
                setDetailInfo(obj.data)
            
                console.log(obj);
            } else {
           
              message.error(obj.msg || obj.message || "请求失败，请重试");
            }
          });
    },[])
    const renderFrom = ()=>{
        let dataList = [
            {label:'发布单位：',value:detailInfo.company ? detailInfo.company :''},
            {label:'发布人：',value:detailInfo.publisher ? detailInfo.publisher :''},
            {label:'举办时间：',value:detailInfo.holdingStartTime ? `${detailInfo.holdingStartTime} 到 ${detailInfo.holdingEndTime}` :''},
            {label:'举办地点：',value:detailInfo.venue ? detailInfo.venue :''},
            {label:'联系人：',value:detailInfo.contacts ? detailInfo.contacts :''},
            {label:'联系电话：',value:detailInfo.contactNumber ? detailInfo.contactNumber :''},
        ]
       
        const formItemLayout = {
            labelCol: {
              span: 3,
            },
            wrapperCol: {
              span: 18,
            },
          };
        return(
            dataList.map((item,index)=>{
                return(
                    <Col span={24} key={index}>
                        <FormItem {...formItemLayout} label={item.label}>
                            <div>{item.value}</div>
                        </FormItem>
                    </Col>
                )
            })
        )
        
    }
    return (
        <div>
            <div className="jobFairDetail">
                <div className="conBox">
                    <div className="topBox">
                        <div className="leftBox">
                            <img src={detailInfo.jobFairPictureUrl ? detailInfo.jobFairPictureUrl :Default} alt=""/>
                        </div>
                        <div className="rightBox">
                            <h2>{detailInfo.name ? detailInfo.name :''}</h2>
                            <Row gutter={[24,8]}>
                                 {renderFrom()}
                            </Row>
                        </div>
                    </div>
                    <div className="btoBox">
                        <div className="info">
                            <h2>招聘会简介</h2>
                            <p>{detailInfo.briefIntroduction ? detailInfo.briefIntroduction :''}</p>
                        </div>
                        <div className="info">
                            <h2>附件下载</h2>
                            {detailInfo.jobFairDocuments && detailInfo.jobFairDocuments.map((item)=>{
                                return<a key={item.id} href={item.photoUrl} download={item.photoUrl} >{item.photoTitle}</a>
                            })}
                            {/* <a href="" download='职位信息表.doc'>职位信息表.doc</a>
                            <a href=""download='公司信息表.doc'>公司信息表.doc</a> */}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
